import { createReducer, on } from '@ngrx/store'
import * as FeatureEPActions from '../feature-edit-project/feature-ep.actions'
import * as FeaturePDActions from '../feature-project-detail/feature-pd.actions'
import * as StageActions from '../stage/stage.actions'
import { HandlerState } from './handler.state'

export const initialState: HandlerState = {
   showSpinner: false,
}

export const handlerReducer = createReducer(
   initialState,
   on(
      FeaturePDActions.retriveProject,
      FeatureEPActions.createProject,
      StageActions.deleteProject,
      FeatureEPActions.editProject,
      StageActions.getAccountInfo,
      StageActions.updateAccountInfo,
      StageActions.updateAvatar,
      (state) => ({
         ...state,
         showSpinner: true,
      })
   ),
   on(
      FeaturePDActions.retriveProjectSuccess,
      FeaturePDActions.retriveProjectFailure,
      FeatureEPActions.editProjectFailure,
      FeatureEPActions.createProjectFailure,
      StageActions.deleteProjectSuccess,
      StageActions.deleteProjectFailure,
      StageActions.getAccountInfoSuccess,
      StageActions.getAccountInfoFailure,
      StageActions.updateAccountInfoSuccess,
      StageActions.updateAccountInfoFailure,
      StageActions.updateAccountInfoSuccess,
      StageActions.updateAccountInfoFailure,
      (state) => ({ ...state, showSpinner: false })
   )
)
